import Vue from 'vue';
import Notifications from "@/components/common/notifications";

Vue.use(Notifications);
